import type { GetNavigationPathFn } from "@tellescope/calendar";

export const makeCalendarRouteFromRangeAndView =
  (viewId: string): GetNavigationPathFn =>
  ({ newViewType, startDate }) => {
    const year = startDate.getFullYear();
    const segments: string[] = ["/calendar", "view", viewId, newViewType, String(year)];
    if (newViewType === "year") {
      return segments.join("/");
    }

    const month = startDate.getMonth();
    segments.push(String(month));
    if (newViewType === "month" || newViewType === "list") {
      return segments.join("/");
    }

    const day = startDate.getDate();
    segments.push(String(day));
    return segments.join("/");
  };
